import Vue from 'vue';
import VueCompositionAPI, {
  computed,
  reactive,
} from '@vue/composition-api';
import { useZipperApi } from './useZipperApi';

const _ = require('lodash');
const Promise = require('bluebird');

// We need to register it again because of Vue instance instantiation issues
Vue.use(VueCompositionAPI);

const state = reactive({
  /**
   * @type {any[][]}
   */
  stats: [],
  loading: true,
  error: {
    load: null,
  },
});

export const useCampaignsStats = () => {
  const { client } = useZipperApi();

  const load = async (storeIds, customerId, year, month) => {
    try {
      if (typeof storeIds === 'string') storeIds = [storeIds];
      state.loading = true;
      let stats = [];
      const storesChunk = _.chunk(storeIds, 300);

      await Promise.map(storesChunk, async (sts) => {
        const res = await client.chain.query
          .campaignStats({
            storeIds: sts, customerId, year, month: month + 1,
          })
          .get(true);
        stats = stats.concat(res);
      }, { concurrency: 5 });

      stats = _.groupBy(_.flatten(stats), 'campaignId');
      stats = Object.values(stats);
      state.stats = stats.filter((el) => el.length > 0);
      state.error.load = false;
    } catch (e) {
      state.error.load = e;
      console.log(e);
    } finally {
      state.loading = false;
    }
  };

  return {
    load,
    stats: computed(() => state.stats),
    loading: computed(() => state.loading),
    error: computed(() => state.error),
  };
};
